import { render, staticRenderFns } from "./VideoPlaceholderCard.vue?vue&type=template&id=bfa8679c&scoped=true&"
import script from "./VideoPlaceholderCard.vue?vue&type=script&lang=js&"
export * from "./VideoPlaceholderCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlaceholderCard.vue?vue&type=style&index=0&id=bfa8679c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa8679c",
  null
  
)

export default component.exports